import {AbModalConfigInterface} from "@/scripts/modules/ab-modal/ab-modal.types";
import {AbModal} from "@/scripts/modules/ab-modal/ab-modal.class";
import {AbLoaderElement} from "@/scripts/components/ab-loader/abLoader.element";
import {createDomElementHandler} from "@/scripts/utils/dom.utils";

export class AbLoaderInModal {

  public start (): void {
    if(!this.modal) {
      this.createModal();
    }
    this.modal.show();
  }

  public stop (): void {
    this.modal.hide();
    this.modal = null;
  }

  private modal: AbModal;

  private modalConfig: AbModalConfigInterface = {
    autoOpen: false,
    handleBackBrowser: false,
    hideBodyOverflow: true,
    id: '',
    attributes: {
      classesWrapper: '',
      classesModal: 'ab-modal--full',
      classesBackdrop: '',
      classesInner: '',
      header: {
        show: false
      },
    }
  }

  constructor() {
    return this;
  }

  private createModal (): void {
    const loaderEl: HTMLElement = createDomElementHandler('ab-loader', [], {}) as AbLoaderElement;
    this.modal = new AbModal(this.modalConfig, loaderEl);
  }

}